var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-tabs",
        {
          staticClass: "limit-tabs",
          attrs: { type: "card" },
          model: {
            value: _vm.activeTab,
            callback: function ($$v) {
              _vm.activeTab = $$v
            },
            expression: "activeTab",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "黑名单", name: "blacklist" } },
            [
              _c(
                "el-card",
                { staticClass: "search-card", attrs: { shadow: "never" } },
                [
                  _c(
                    "el-form",
                    {
                      staticClass: "demo-form-inline",
                      attrs: { inline: true, model: _vm.queryParams },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "类型" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "120px" },
                              attrs: { placeholder: "全部", clearable: "" },
                              model: {
                                value: _vm.queryParams.targetType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryParams, "targetType", $$v)
                                },
                                expression: "queryParams.targetType",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "IP", value: "IP" },
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { label: "用户", value: "USER" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "目标值" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "IP或用户ID", clearable: "" },
                            model: {
                              value: _vm.queryParams.targetValue,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryParams, "targetValue", $$v)
                              },
                              expression: "queryParams.targetValue",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                icon: "el-icon-search",
                              },
                              on: { click: _vm.handleQuery },
                            },
                            [_vm._v("搜索")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "success", icon: "el-icon-plus" },
                              on: { click: _vm.handleAdd },
                            },
                            [_vm._v("手动封禁")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-card",
                { staticClass: "table-card", attrs: { shadow: "never" } },
                [
                  _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.loading,
                          expression: "loading",
                        },
                      ],
                      staticStyle: { width: "100%" },
                      attrs: {
                        data: _vm.list,
                        border: "",
                        "empty-text": "暂无数据",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          prop: "id",
                          label: "ID",
                          width: "80",
                          align: "center",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "targetType",
                          label: "类型",
                          width: "80",
                          align: "center",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-tag",
                                  {
                                    attrs: {
                                      type:
                                        scope.row.targetType === "IP"
                                          ? "warning"
                                          : "info",
                                      size: "small",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(scope.row.targetType) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "targetValue",
                          label: "目标值",
                          "min-width": "160",
                          "show-overflow-tooltip": "",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "hitUri",
                          label: "触发接口",
                          "min-width": "180",
                          "show-overflow-tooltip": "",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "hitCount",
                          label: "触发计数",
                          width: "90",
                          align: "center",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "maxRequests",
                          label: "阈值",
                          width: "80",
                          align: "center",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "封禁期限",
                          width: "130",
                          align: "center",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                scope.row.blockUntil
                                  ? _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.formatDateTime(
                                            scope.row.blockUntil
                                          )
                                        )
                                      ),
                                    ])
                                  : _c(
                                      "el-tag",
                                      {
                                        attrs: {
                                          type: "danger",
                                          size: "small",
                                        },
                                      },
                                      [_vm._v("永久")]
                                    ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "状态", width: "80", align: "center" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-tag",
                                  {
                                    attrs: {
                                      type:
                                        scope.row.status === 0
                                          ? "danger"
                                          : "success",
                                      size: "small",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          scope.row.status === 0
                                            ? "封禁中"
                                            : "已解封"
                                        ) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "createTime",
                          label: "创建时间",
                          width: "170",
                          align: "center",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.formatDateTime(scope.row.createTime)
                                    )
                                  ),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "操作",
                          width: "100",
                          fixed: "right",
                          align: "center",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                scope.row.status === 0
                                  ? _c(
                                      "el-button",
                                      {
                                        staticStyle: { color: "#67c23a" },
                                        attrs: { type: "text", size: "small" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleUnblock(scope.row)
                                          },
                                        },
                                      },
                                      [_vm._v("解封")]
                                    )
                                  : _vm._e(),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.total > 0
                    ? _c("el-pagination", {
                        staticStyle: {
                          "margin-top": "20px",
                          "text-align": "right",
                        },
                        attrs: {
                          "current-page": _vm.queryParams.page,
                          "page-size": _vm.queryParams.limit,
                          total: _vm.total,
                          layout: "total, sizes, prev, pager, next, jumper",
                          "page-sizes": [10, 20, 50, 100],
                        },
                        on: {
                          "size-change": _vm.handleSizeChange,
                          "current-change": _vm.handleCurrentChange,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-dialog",
                {
                  attrs: {
                    title: "手动封禁",
                    visible: _vm.blockVisible,
                    width: "450px",
                    "close-on-click-modal": false,
                  },
                  on: {
                    "update:visible": function ($event) {
                      _vm.blockVisible = $event
                    },
                  },
                },
                [
                  _c(
                    "el-form",
                    {
                      ref: "blockForm",
                      attrs: {
                        model: _vm.blockForm,
                        rules: _vm.blockRules,
                        "label-width": "100px",
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "类型", prop: "targetType" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.blockForm.targetType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.blockForm, "targetType", $$v)
                                },
                                expression: "blockForm.targetType",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: "IP" } }, [
                                _vm._v("IP"),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: "USER" } }, [
                                _vm._v("用户"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "目标值", prop: "targetValue" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入IP地址或用户ID" },
                            model: {
                              value: _vm.blockForm.targetValue,
                              callback: function ($$v) {
                                _vm.$set(_vm.blockForm, "targetValue", $$v)
                              },
                              expression: "blockForm.targetValue",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "封禁时长" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              on: { change: _vm.onPermanentChange },
                              model: {
                                value: _vm.blockForm.permanent,
                                callback: function ($$v) {
                                  _vm.$set(_vm.blockForm, "permanent", $$v)
                                },
                                expression: "blockForm.permanent",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: true } }, [
                                _vm._v("永久"),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: false } }, [
                                _vm._v("定时"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      !_vm.blockForm.permanent
                        ? _c(
                            "el-form-item",
                            { attrs: { label: "时长(秒)" } },
                            [
                              _c("el-input-number", {
                                staticStyle: { width: "100%" },
                                attrs: { min: 1, max: 86400 },
                                model: {
                                  value: _vm.blockForm.durationSeconds,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.blockForm,
                                      "durationSeconds",
                                      $$v
                                    )
                                  },
                                  expression: "blockForm.durationSeconds",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "dialog-footer",
                      attrs: { slot: "footer" },
                      slot: "footer",
                    },
                    [
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function ($event) {
                              _vm.blockVisible = false
                            },
                          },
                        },
                        [_vm._v("取消")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", loading: _vm.blockLoading },
                          on: { click: _vm.submitBlock },
                        },
                        [_vm._v("确认封禁")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-tab-pane",
            { attrs: { label: "限流配置", name: "config" } },
            [_c("rate-limit-config")],
            1
          ),
          _vm._v(" "),
          _c(
            "el-tab-pane",
            { attrs: { label: "灰度白名单", name: "grayRoute" } },
            [_c("gray-route-config")],
            1
          ),
          _vm._v(" "),
          _c(
            "el-tab-pane",
            { attrs: { label: "灰度命中记录", name: "grayRouteLog" } },
            [_c("gray-route-log")],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }